import { Component, ErrorInfo, ReactNode } from "react";
import { Html } from "@react-three/drei";

interface Props {
  children: ReactNode;
  sceneName: string;
  onReset: () => void;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(
      `[ErrorBoundary] Scene "${this.props.sceneName}" failed to load.`,
      error,
      info,
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <Html
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.85)",
            color: "#fff",
            zIndex: 9999,
            padding: "2rem",
            textAlign: "center",
            fontFamily: "sans-serif",
          }}
        >
          <h2 style={{ marginBottom: "0.5rem" }}>
            Could not load scene: {this.props.sceneName}
          </h2>
          <p
            style={{
              fontSize: "0.85rem",
              color: "#f88",
              maxWidth: 640,
              wordBreak: "break-all",
              marginBottom: "1.5rem",
            }}
          >
            {this.state.errorMessage}
          </p>
          <button
            onClick={this.props.onReset}
            style={{
              padding: "0.6rem 1.4rem",
              fontSize: "1rem",
              cursor: "pointer",
              borderRadius: 6,
              border: "none",
              background: "#fff",
              color: "#000",
            }}
          >
            Back to Menu
          </button>
        </Html>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
